const translations = {
    applicationDate: 'Application date {{date}}',
    generated: 'Generated {{date}}',
    recordStatement:
        'Record of pesticide application prepared to satisfy state recordkeeping requirements.',
    recordStatementWithCitation:
        'Record of pesticide application prepared to satisfy state recordkeeping requirements, including {{citation}}.',
    title: 'Product Usage Report',
    workOrder: 'Work Order {{workOrderKey}}'
};

export default translations;
